import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Progress, Row } from "reactstrap";
import styles from "./styles.module.css";
import useProfileCompletion from "../../../../../helpers/Common/useProfileCompletion";

const ProfileCompletion = () => {
  const navigate = useNavigate();
  const { completionPercentage } = useProfileCompletion();

  const numericPercentage = Number(completionPercentage) || 0;
  const isProfileCompleted = numericPercentage >= 100;

  const scrollToForm = useCallback(() => {
    const profileForm = document.getElementById("profile-form");
    if (profileForm) {
      profileForm.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, []);

  const handleCompleteProfileClick = () => {
    navigate("/candidate/profile/update");
    // Delay scroll slightly to allow the DOM on the new route to render if needed
    setTimeout(() => {
      scrollToForm();
    }, 100);
  };

  console.log("Profile completion percentage:", numericPercentage);

  return (
    <div className={styles.trackerContainer}>
      <Row>
        <Col lg={4}>
          <div className={styles.leftBox}>
            <h1>{numericPercentage}%</h1>
            <h4>of your profile is completed</h4>
          </div>
        </Col>
        <Col lg={8}>
          <div className={styles.progressbarSec}>
            <div className={styles.progressDiv}>
              <Progress
                value={numericPercentage}
                color={isProfileCompleted ? "success" : "primary"}
                className={styles.progress}
              />
            </div>
          </div>

          <h4 className={styles.smallHeading}>
            {isProfileCompleted
              ? "Profile Completed"
              : "Only 100% completed profiles appear in job searches. Finish your profile now to get noticed!"}
          </h4>

          <p className={styles.hintText}>
            {!isProfileCompleted
              ? "The more updated your profile, the better your chances of getting hired."
              : "Congratulations on completing your profile! Your thorough profile increases your chances of finding the right job."}
          </p>

          {!isProfileCompleted && (
            <button
              type="button"
              className={`btn btn-primary ${styles.button}`}
              onClick={handleCompleteProfileClick}
            >
              Complete profile
            </button>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ProfileCompletion;
